import LZString from "lz-string";

export const encodeShare = (state) =>
  LZString.compressToEncodedURIComponent(JSON.stringify(state));

export const decodeShare = (s) => {
  try {
    const raw = LZString.decompressFromEncodedURIComponent(s);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const readShareFromUrl = () => {
  const m = window.location.hash.match(/[#&]s=([^&]+)/);
  return m ? decodeShare(m[1]) : null;
};

export const buildShareUrl = (state) =>
  `${window.location.origin}${window.location.pathname}#s=${encodeShare(state)}`;
